import * as Yup from 'yup';

export const validationSchema = Yup.object().shape(
  {
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    phone: Yup.string().required('Phone is required'),
    comments: Yup.string(),
    terms: Yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
    subscribe: Yup.boolean().optional(),
    location: Yup.string().required('Location is required'),
  },
  [['phone', 'phone']],
);

export interface IFormSchema {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  location: string;
  comments: string;
  terms: boolean;
  subscribe?: boolean;
  smsOptIn?: boolean;
}
